module.exports = __webpack_public_path__ + "static/media/hero-popup.904e6ec4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-popup.svg
// module id = 1380
// module chunks = 0